// removed by extract-text-webpack-plugin
module.exports = {"majorWrapper":"_13wJmn_08Pd5qKyAJLwR5i","cityWrapper":"_1yJQOsSjmCGEX0WeFtIJhg","cityImage":"o_c_B_1UOmdWy0Cnt53UP","properties":"_3BsaawvSOiupGkl12XdadP","linkByTypes":"_29F8xXqg3Asv110tGDA8pa","cityName":"_1cSRMb8iOHOExcruNy0bbx","blockWrapper":"_39nTM9bAYXfJ48UAPsdXO1","roomsWrapper":"_1u_a4Q3nEfAzxy1HzrPajG","typeTitle":"_1dJZQPb0mKwOhbw8ZCqPT0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MajorCities/MajorCities.scss
// module id = 1637
// module chunks = 0